export default __webpack_public_path__ + "images/31fddfc0e67ac5cdae68e90c2b81b58e.png";